import React from 'react'
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";
import { useSelector } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CurrencyProvider } from './pages/currency/currencyContext';
import { UserLogin, Logout, Question, CustomerEdit, AppLayout, AdminDashboard, Orders, OrderDetails, Customers,
 Sales, Notifications, Feedbacks, Staff, NewStaff, Products, ProductEdit, NewProduct, Profile, Lot, LotDetails,
 MonthlyInvoice, InvoiceDetails, HiraTechUKExpenses, HiraTechPKExpenses, SuppliersPage, PostingEntries,
 SuppliersDetailPage, Category, BillsPage, Paid, Unpaid, Customer, ExpensesPage, PlaceOrders, Member, MemberEdit,ProductList,CurrencySettings, Details
} from "./adminExportFiles";
import ProtectedRoute from './components/ProtectedRoute';

// ===== IMPORT DraftOrders =====
import DraftOrders from './pages/orders/DraftOrders'; // Path apne project ke hisaab se adjust karein

const theme = createTheme({
  palette: {
    primary: {
      main: '#004aad',
      dark: '#004aad'
    },
  },
});

function App() {
  const { access_token } = useSelector(state => state.auth);

  return (
    <ThemeProvider theme={theme}>
        <CurrencyProvider>
      <BrowserRouter>
        <Routes>
          <Route path="logout" element={<Logout />} />
          <Route path="login" element={<UserLogin />} />

          <Route path="admin" element={access_token ? <AppLayout /> : <Navigate to="/login" />}>
            <Route index path="dashboard" element={<ProtectedRoute requiredPage="dashboard"><AdminDashboard /></ProtectedRoute>} />
            <Route path="customers" element={<ProtectedRoute requiredPage="customers"><Customers /></ProtectedRoute>} />
            <Route path="inactive" element={<ProtectedRoute requiredPage="inactive"><Customer /></ProtectedRoute>} />
            <Route path="customer/edit/:id" element={<ProtectedRoute requiredPage="customers"><CustomerEdit /></ProtectedRoute>} />
            <Route path="orders" element={<ProtectedRoute requiredPage="orders"><Orders /></ProtectedRoute>} />
            <Route path="order/details/:id" element={<ProtectedRoute requiredPage="orders"><OrderDetails /></ProtectedRoute>} />
            <Route path="notifications" element={<ProtectedRoute requiredPage="notifications"><Notifications /></ProtectedRoute>} />
            <Route path="question" element={<ProtectedRoute requiredPage="question"><Question /></ProtectedRoute>} />
            <Route path="monthly-invoices" element={<ProtectedRoute requiredPage="monthly-invoices"><MonthlyInvoice /></ProtectedRoute>} />
            
            {/* ===== PLACE ORDER ROUTE ===== */}
            <Route path="placeorders" element={<ProtectedRoute requiredPage="placeorders"><PlaceOrders /></ProtectedRoute>} />
            
            {/* ===== DRAFTS ROUTE (NEW) ===== */}
            <Route path="drafts" element={<ProtectedRoute requiredPage="placeorders"><DraftOrders /></ProtectedRoute>} />
            
            <Route path="productList" element={<ProtectedRoute requiredPage="productList"><ProductList /></ProtectedRoute>} />
            <Route path="posting" element={<ProtectedRoute requiredPage="posting"><PostingEntries /></ProtectedRoute>} />
            <Route path="/admin/invoice-detail/:id" element={<ProtectedRoute requiredPage="monthly-invoices"><InvoiceDetails /></ProtectedRoute>} />
            <Route path="feedbacks" element={<ProtectedRoute requiredPage="feedbacks"><Feedbacks /></ProtectedRoute>} />
            <Route path="products" element={<ProtectedRoute requiredPage="products"><Products /></ProtectedRoute>} />
            <Route path="category" element={<ProtectedRoute requiredPage="category"><Category /></ProtectedRoute>} />
            <Route path="product/new" element={<ProtectedRoute requiredPage="products"><NewProduct /></ProtectedRoute>} />
            <Route path="product/edit/:id" element={<ProtectedRoute requiredPage="products"><ProductEdit /></ProtectedRoute>} />
            <Route path="profile" element={<ProtectedRoute requiredPage="profile"><Profile /></ProtectedRoute>} />
            <Route path="sales" element={<ProtectedRoute requiredPage="sales"><Sales /></ProtectedRoute>} />
            <Route path="lot" element={<ProtectedRoute requiredPage="lot"><Lot /></ProtectedRoute>} />
            <Route path="/admin/lot-detail/:id" element={<ProtectedRoute requiredPage="lot"><LotDetails /></ProtectedRoute>} />
            <Route path="expenses-uk" element={<ProtectedRoute requiredPage="expenses-uk"><HiraTechUKExpenses /></ProtectedRoute>} />
            <Route path="expenses-pk" element={<ProtectedRoute requiredPage="expenses-pk"><HiraTechPKExpenses /></ProtectedRoute>} />
            <Route path="/admin/pk-suppliers" element={<ProtectedRoute requiredPage="expenses-uk"><SuppliersPage /></ProtectedRoute>} />
            <Route path="/admin/bills" element={<ProtectedRoute requiredPage="expenses-uk"><BillsPage /></ProtectedRoute>} />
            <Route path="/admin/pk-expenses" element={<ProtectedRoute requiredPage="expenses-uk"><ExpensesPage /></ProtectedRoute>} />
            <Route path="/admin/supplier-details/:id" element={<ProtectedRoute requiredPage="expenses-uk"><SuppliersDetailPage /></ProtectedRoute>} />
            <Route path="currency" element={<ProtectedRoute requiredPage="currency"><CurrencySettings /></ProtectedRoute>} />
            <Route path="/admin/paid" element={<ProtectedRoute requiredPage="expenses-uk"><Paid /></ProtectedRoute>} />
            <Route path="/admin/unpaid" element={<ProtectedRoute requiredPage="expenses-uk"><Unpaid /></ProtectedRoute>} />
            <Route path="staff" element={<ProtectedRoute requiredPage="staff"><Staff /></ProtectedRoute>} />
            <Route path="details" element={<ProtectedRoute requiredPage="details"><Details /></ProtectedRoute>} />
            <Route path="staf" element={<ProtectedRoute requiredPage="staf"><Member /></ProtectedRoute>} />
            <Route path="member/edit/:id" element={<ProtectedRoute requiredPage="staf"><MemberEdit /></ProtectedRoute>} />
            <Route path="staff/edit/:id" element={<ProtectedRoute requiredPage="staff"><CustomerEdit /></ProtectedRoute>} />
            <Route path="newstaff" element={<ProtectedRoute requiredPage="staff"><NewStaff /></ProtectedRoute>} />
          </Route>

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
        </CurrencyProvider>
    </ThemeProvider>
  );
}

export default App;